import { render, staticRenderFns } from "./chartSOC.vue?vue&type=template&id=49b43ac0&"
import script from "./chartSOC.vue?vue&type=script&lang=js&"
export * from "./chartSOC.vue?vue&type=script&lang=js&"
import style0 from "./chartSOC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports